import { useEffect, useState } from 'react';
import cls from './GameOnb.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { contentGameOnb, contentType } from './assets';
import nextButtonImg from '../../shared/assets/images/next-button.svg';
import { itIsGame } from '../../shared/redux/game/slice';
import IceSrc from '../../shared/assets/images/obstacles/ice-2.svg';
import BearSrc from '../../shared/assets/images/obstacles/bear-1.svg';
import SealSrc from '../../shared/assets/images/obstacles/seal.svg';
import IcebergSrc from '../../shared/assets/images/obstacles/ice-3.svg';
import { sounds } from '../../shared/ui/Sound/assets';

export const GameOnb = () => {
  const dispatch = useDispatch();
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const currentLevel = useSelector((state: RootState) => state.game.currentLevel);
  const [currentContent, setCurrentContent] = useState<contentType>(contentGameOnb[0]);
  const [page, setPage] = useState(1);
  useEffect(() => {
    setCurrentContent(contentGameOnb[currentLevel - 1]);
  }, [currentLevel]);
  const getCls = () => {
    if (page === 1) {
      return currentContent.cls;
    } else {
      return cls.page2;
    }
  };
  const pStyle = currentLevel === 2 ? { fontSize: '17px' } : {};
  return (
    <div className={`${cls.GameOnb} ${getCls()} page-container`}>
      {page === 1 ? (
        <>
          <div className="text-container" style={{ top: '12%' }}>
            <h2
              className="text-bg-h1"
              style={{
                marginTop: '1.2px',
                position: 'absolute',
                left: '50%',
                width: '350px',
                transform: 'translateX(-176.2px)',
              }}>
              {currentContent.head.map((el, idx) => (
                <>
                  {el}
                  <br key={idx} />
                </>
              ))}
            </h2>
            <h2
              style={{
                position: 'absolute',
                left: '50%',
                width: '350px',
                transform: 'translateX(-50%)',
              }}>
              {currentContent.head.map((el, idx) => (
                <>
                  {el}
                  <br key={idx} />
                </>
              ))}
            </h2>
          </div>
          <div className={`text-container ${cls.desc}`}>
            <p className="text-bg-p">
              {currentContent.desc.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                </>
              ))}
            </p>
            <p>
              {currentContent.desc.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                </>
              ))}
            </p>
          </div>
          <div className={`text-container ${cls.charac}`}>
            <p className="text-bg-p">
              {currentContent.characteristic.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                </>
              ))}
            </p>
            <p>
              {currentContent.characteristic.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                </>
              ))}
            </p>
          </div>
          <img
            alt="Next button"
            src={nextButtonImg}
            className={cls.buttonNext}
            onClick={() => {
              if (isSound) {
                sounds.btn.play();
              }
              setPage(2);
            }}
          />
        </>
      ) : (
        <>
          <div className={`text-container ${cls.page2Text}`}>
            <p className="text-bg-p" style={pStyle}>
              {' '}
              {currentContent.page2Text.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                  <br />
                </>
              ))}
            </p>
            <p style={pStyle}>
              {' '}
              {currentContent.page2Text.map((el, idx) => (
                <>
                  {el} <br key={idx} />
                  <br />
                </>
              ))}
            </p>
          </div>

          {currentLevel === 2 && (
            <div className={`${cls.examplesContainer} ${cls.examplesContainer1}`}>
              <img alt="Ice" src={IceSrc} style={{ width: '73px' }} />
              <img alt="Bear" src={BearSrc} style={{ width: '51px' }} />
              <img alt="Seal" src={SealSrc} style={{ width: '51px' }} />
            </div>
          )}

          {currentLevel === 3 && (
            <div className={`${cls.examplesContainer} ${cls.examplesContainer2}`}>
              <img alt="Bear" src={BearSrc} style={{ width: '51px' }} />
              <img alt="Seal" src={SealSrc} style={{ width: '51px' }} />
              <img alt="Iceberg" src={IcebergSrc} style={{ width: '81px' }} />
            </div>
          )}

          <img alt="btn" src={currentContent.shipImg} className={cls.shipImg} />
          <button>
            <img
              alt="btn"
              className={cls.startButton}
              src={currentContent.buttonImg}
              onClick={() => {
                if (isSound) {
                  sounds.btn.play();
                }
                dispatch(itIsGame());
              }}
            />
          </button>
        </>
      )}
    </div>
  );
};
